import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          精选推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <article key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 font-label font-medium mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1.5">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}